import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum SearchClientFormErrorStatesEnum {
    GetClientFailed = ErrorStateScheduleEnum.SearchClientFormStatesStartIndex
}
